"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInterviewQuestionProperty = exports.interviewQuestionPropertyDefinition = void 0;
exports.interviewQuestionPropertyDefinition = {
    view: {
        label: 'Question',
        style: 'h3',
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'interview-question',
};
const isInterviewQuestionProperty = (prop) => {
    return prop.name === exports.interviewQuestionPropertyDefinition.name;
};
exports.isInterviewQuestionProperty = isInterviewQuestionProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW50ZXJ2aWV3LXF1ZXN0aW9uLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvaW50ZXJ2aWV3LXF1ZXN0aW9uLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsbUNBQW1DLEdBQUc7SUFDakQsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLFVBQVU7UUFDakIsS0FBSyxFQUFFLElBQUk7S0FDWjtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxvQkFBb0I7Q0FDSyxDQUFBO0FBSTFCLE1BQU0sMkJBQTJCLEdBQUcsQ0FBQyxJQUFrQixFQUFxQyxFQUFFO0lBQ25HLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSywyQ0FBbUMsQ0FBQyxJQUFJLENBQUE7QUFDL0QsQ0FBQyxDQUFBO0FBRlksUUFBQSwyQkFBMkIsK0JBRXZDIn0=